const SERVER_PORT_SERVICE_LABELS: Record<string, string> = {
  web_http: 'Web HTTP',
  web_https: 'Web HTTPS',
  tcp_modbus: 'Modbus TCP',
  ssh: 'SSH',
  messaging_server: 'Messaging Server',
};

const VIRTUAL_IP_KEY_PATTERN = /^virtual_ip-(\d+)$/i;

export function formatServerPortServiceName(rawName: string | undefined | null): string {
  if (rawName === null || rawName === undefined) {
    return '—';
  }

  const trimmed = rawName.trim();
  if (!trimmed || trimmed === '—') {
    return '—';
  }

  const normalizedKey = trimmed.toLowerCase().replace(/\s+/g, '_');
  const mapped = SERVER_PORT_SERVICE_LABELS[normalizedKey];
  if (mapped) {
    return mapped;
  }

  if (trimmed.includes('_')) {
    return trimmed
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  return trimmed;
}

export function parseVirtualIpEntrySuffix(key: string): number | null {
  const match = key.match(VIRTUAL_IP_KEY_PATTERN);
  return match ? Number(match[1]) : null;
}

export function formatVirtualIpEntryLabel(key: string): string {
  const suffix = parseVirtualIpEntrySuffix(key);
  if (suffix !== null) {
    return `Virtual IP-${suffix}`;
  }

  return key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function compareVirtualIpEntryKeys(left: string, right: string): number {
  const leftSuffix = parseVirtualIpEntrySuffix(left);
  const rightSuffix = parseVirtualIpEntrySuffix(right);

  if (leftSuffix !== null && rightSuffix !== null) {
    return leftSuffix - rightSuffix;
  }
  if (leftSuffix !== null) {
    return -1;
  }
  if (rightSuffix !== null) {
    return 1;
  }

  return left.localeCompare(right);
}
